module.exports = __webpack_public_path__ + "img/traffic-light-green.da06ebbf.svg";